export const colors = [
  '#000000',
  '#ffffff',
  '#edecf6',
  '#39B0FF',
  '#04B58B',
  '#3E9C4B',
  '#B6BC00',
  '#E59100',
  '#E55C00',
  '#EE1F50',
  '#D6198A',
  '#A4328A',
  '#4f2d80'
];
